import { omit } from 'lodash';

import {
  SET_LANGUAGE_ROWS,
  SET_LOCALE_ORDER,
  ADD_LANGUAGE,
  DELETE_LANGUAGE,
  UPDATE_LANGUAGE_CELL,
  OPEN_ADD_LANGUAGE_MODAL,
  CLOSE_ADD_LANGUAGE_MODAL,
} from './types';
import { flatToGrouped } from './utils';

const initialState = {
  languageRows: [],
  localeOrder: [],
  isAddLanguageModalOpen: false,
};

export default (state = initialState, { payload, type } = {}) => {
  switch (type) {
  case OPEN_ADD_LANGUAGE_MODAL:
    return { ...state, isAddLanguageModalOpen: true };
  case CLOSE_ADD_LANGUAGE_MODAL:
    return { ...state, isAddLanguageModalOpen: false };
  case SET_LANGUAGE_ROWS: {
    const flat = payload || [];
    const grouped = flat.length > 0 ? flatToGrouped(flat) : [];
    const locales = [...new Set(flat.map((r) => r.locale))].sort((a, b) => a.localeCompare(b));
    const localeOrder = (state.localeOrder || []).length > 0 ? state.localeOrder : locales;
    return { ...state, languageRows: grouped, localeOrder };
  }
  case SET_LOCALE_ORDER: {
    return { ...state, localeOrder: payload || [] };
  }
  case ADD_LANGUAGE: {
    const newLocale = payload;
    const rows = state.languageRows.length > 0
      ? state.languageRows.map((row) => ({ ...row, [newLocale]: '' }))
      : [{
        path: 'default', page: '', textName: 'default', [newLocale]: '',
      }];
    const currentOrder = state.localeOrder || [];
    const localeOrder = currentOrder.includes(newLocale)
      ? currentOrder
      : [...currentOrder, newLocale];
    return { ...state, languageRows: rows, localeOrder };
  }
  case DELETE_LANGUAGE: {
    const localeToDelete = payload;
    return {
      ...state,
      languageRows: state.languageRows.map((row) => omit(row, localeToDelete)),
      localeOrder: (state.localeOrder || []).filter((l) => l !== localeToDelete),
    };
  }
  case UPDATE_LANGUAGE_CELL: {
    const { path, locale, value } = payload;
    return {
      ...state,
      languageRows: state.languageRows.map((r) => (
        r.path === path ? { ...r, [locale]: value } : r
      )),
    };
  }
  default:
    return state;
  }
};
